<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab href="#searchpainterdashboard" ripple>{{ $t('จำนวนการลงทะเบียนหาช่าง') }}</v-tab>
      <v-tab href="#painterbystatus" ripple>{{ $t('จำนวนและรายชื่อช่างตามสถานะ') }}</v-tab>
      <v-tab href="#painterregistersuccessdashboard" ripple>{{
        $t('จำนวนและรายชื่อช่างที่ลงทะเบียนสำเร็จ')
      }}</v-tab>
      <v-tab href="#provincepainterdashboard" ripple>{{
        $t('จำนวนและรายชื่อจังหวัดที่ช่างอยู่')
      }}</v-tab>
      <!-- <v-tab href="#dealersendquotation" ripple>{{
        $t('รายชื่อร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า')
      }}</v-tab> -->
      <!-- <v-tab href="#orderscompletepayment" ripple>{{ $t('รายชื่อร้านการชำระเงินสำเร็จ') }}</v-tab> -->
      <!-- <v-tab href="#ordersshipping" ripple>{{ $t('รายชื่อร้านจัดส่งสำเร็จ') }}</v-tab> -->
      <v-tab href="#provinceofsearchpainterdashboard" ripple>{{
        $t('รายชื่อจังหวัดของช่างที่ถูกค้นหา')
      }}</v-tab>
      <v-tab href="#channeltoquotationpaintersdashboard" ripple>{{
        $t('จำนวนและช่องทางในการติดต่อหาช่าง')
      }}</v-tab>
    </v-tabs>
    <div>
      <components :is="currentView"></components>
    </div>
  </div>
</template>

<script>
import searchpainterdashboard from './searchpainterdashboard.vue'
import painterregistersuccessdashboard from './painterregistersuccessdashboard.vue'
import provincepainterdashboard from './provincepainterdashboard.vue'

import provinceofsearchpainterdashboard from './provinceofsearchpainterdashboard.vue'
import channeltoquotationpaintersdashboard from './channeltoquotationpaintersdashboard.vue'
import painterbystatus from './painterbystatus.vue'

export default {
  components: {
    searchpainterdashboard,
    painterregistersuccessdashboard,
    provincepainterdashboard,

    provinceofsearchpainterdashboard,
    channeltoquotationpaintersdashboard,
    painterbystatus
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'searchpainterdashboard'
    }
  },
  data() {
    return {
      currentView: ''
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      //   this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Painter/main.vue